// extracted by mini-css-extract-plugin
export default {"List":"BookList_List__S3uq3"};